import {postMethod, getMethod} from '~/api'

async function post(request) {
    return await postMethod('/proxy/ai/threads/messages', request)
}

async function get(request) {
    return await getMethod('/proxy/ai/threads/messages', request)
}

export {post, get}
